import React, { useState } from "react";
import { Grid, Button, AppBar, Toolbar, IconButton } from "@mui/material";
import SIALogo from "../assets/SIALogo.png";
import Notification from "../assets/Notification.png";

import "./Home.css";
import LoginForm from "./Login";
import SIABackGround from "../assets/SIABackGround.png";
import MenuBar from "./MenuBar";
import SignupForm from "./Signup";
import { ToastContainer } from "react-toastify";
import { Navigate, useNavigate } from "react-router";

const Home = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);

  const handleSwitchToSignup = () => {
    setIsLogin(false);
  };

  const handleSwitchToLogin = () => {
    setIsLogin(true);
  };

  return (
    <div>
      <ToastContainer />
      <div>
        <AppBar position="static">
          <Toolbar className="header-toolbar">
            <IconButton edge="start" color="inherit" aria-label="logo">
              <img src={SIALogo} alt="sia logo" className="logo" />
            </IconButton>

            <div>
              <Button className="app-button">Get the App</Button>
              <Button className="">
                <img src={Notification} alt="sia notification" />
              </Button>
              {/* <Button className="login-button">Login</Button> */}
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <div className="auth-wrapper">
        <Grid container className="auth-container">
          <Grid item xs={12} md={6} className="left-side">
            <img src={SIABackGround} alt="sia" />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            className="right-side"
            sx={{ justifyContent: "end" }}
          >
            <div className="form-toggle">
              {isLogin ? (
                <LoginForm onSwitchToSignup={handleSwitchToSignup} />
              ) : (
                <SignupForm onSwitchToLogin={handleSwitchToLogin} />
              )}
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="row3"></div>
    </div>
  );
};

export default Home;
